<div class="login">
  <!-- Left Image Section -->

  <div class="image-wrapper pr-xl-1">
    <!-- Image Slider -->
    <div #imageSliderRef [class.hide]="!slider" class="keen-slider image-slider">
      @for (img of imageSources; track img) {
        <div class="keen-slider__slide">
          <img alt="" class="main-img" [src]="img" />
        </div>
      }
    </div>

    <!-- logo -->
    <img alt="" class="icon-size" src="assets/logo/logo.png" />

    <!--  Text slider  -->
    <div [class.hide]="!slider" class="slider-position">
      <div class="navigation-wrapper">
        <div #sliderRef class="keen-slider text-wrapper">
          <div class="slider-text keen-slider__slide">
            <div>
              <h6 translate>Welcome to your club community!</h6>
              <p translate>Stay networked with your club, exchange ideas and organize everything in one place.</p>
            </div>
          </div>
          <div class="slider-text keen-slider__slide">
            <div>
              <h6 translate>Everything you need for your club - in one place.</h6>
              <p translate>Simply register, contact members, plan appointments and achieve more together.</p>
            </div>
          </div>
          <div class="slider-text keen-slider__slide">
            <div>
              <h6 translate>Stay connected - anytime, anywhere.</h6>
              <p translate>Access important information, share news and collaborate with your team.</p>
            </div>
          </div>
        </div>
        <div class="align-arrow-right mt-24">
          <app-icon (click)="slider.prev()" [cssStyle]="{ cursor: 'pointer', color: 'var(--white)' }" color="#ffffff" iconName="left-arrow-circle" size="55px"></app-icon>
          @if (slider) {
            <app-icon (click)="slider.next()" [cssStyle]="{ cursor: 'pointer', marginLeft: '22px' }" color="#ffffff" iconName="right-arrow-circle" size="55px"></app-icon>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Right Form Section -->

  <div class="login-form padding-m">
    <div>
      <div class="d-flex">
        <app-icon [cssStyle]="{ marginBottom: '-20px' }" iconName="logo" size="28px"></app-icon>&nbsp;
        <span class="login-form__logo-text">{{ 'APP_NAME' | translate }}</span>
        <!--        <app-icon iconName="logo-text" size="100px"></app-icon>-->
      </div>
      <h2 class="heading-text mt-50" translate>loginForm.Login into your account</h2>
    </div>
    <form (ngSubmit)="login()" [formGroup]="form" class="mt-50 padding-m">
      <div>
        <label for="username" translate>loginForm.Username</label>
        <div class="input-icon-prefix mt-10">
          <input [placeholder]="'loginForm.Username' | translate" class="login-form__input" formControlName="username" id="username" name="username" type="text" />
          <app-icon [cssStyle]="{ marginBottom: '-9px' }" color="var(--slate-gray)" iconName="envelope"></app-icon>
        </div>
        <app-form-error [control]="form.get('username')" [name]="'Username' | translate"></app-form-error>
      </div>
      <div class="mt-16">
        <label for="password" translate>loginForm.Password</label>
        <div class="input-icons-pre-post mt-10">
          <input
            #password
            [placeholder]="'loginForm.Password (6+ characters)' | translate"
            class="login-form__input"
            formControlName="password"
            id="password"
            name="password"
            type="{{ showPassword ? 'text' : 'password' }}"
          />
          <app-icon [cssStyle]="{ marginBottom: '-9px' }" class="env-icon" color="var(--slate-gray)" iconName="lock"></app-icon>
          <app-icon
            (click)="togglePasswordVisibility()"
            [cssStyle]="{ marginBottom: '-9px' }"
            [iconName]="showPassword ? 'eye-open' : 'eye-hide'"
            class="env-icon-right"
            color="var(--slate-gray)"
          ></app-icon>
        </div>
        <app-form-error [control]="form.get('password')" [name]="'Password' | translate"></app-form-error>
      </div>
      <p class="mt-16 normal-text" routerLink="/forgot-password" translate>loginForm.I forgot my password</p>
      <div class="mt-26">
        <app-button (click)="login()" [idleText]="'Login' | translate" [isLoading]="isLoading" [type]="'submit'" cssClass="button-primary button-full" size="large"></app-button>
      </div>
    </form>
    <!--    <p class="account-text mt-24" translate>loginForm.Don't have an account?</p>-->
    <div class="mt-16">
      <!--            <app-button [disabled]="isLoading" [idleText]="'loginForm.Sign up for Verein.cloud' | translate" size="large" cssClass="button-primary-opaque button-full"></app-button>-->
    </div>
  </div>
</div>

<div class="lang-selector">
  <img alt="-" class="lang-flag-icon" src="assets/lang-flags/{{ selectedLanguage.toLowerCase() }}.png" />
  <app-language-selector (selectedLanguage)="selectedLanguage = $event" [openAbove]="true"></app-language-selector>
</div>
